import React from 'react';
import { SvgProps } from '../../types/icon';
import { css, keyframes } from '@emotion/react'
import styled from '@emotion/styled';

const rotate = keyframes`
  100% {
    transform: rotate(360deg);
  }
`
const dash = keyframes`
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35px;
  }
  100% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -124px;
  }
`
const Svg = styled.svg`
  animation: ${rotate} 2s linear infinite;
  transform-origin: center center;
  margin: auto;
`
const Path = styled.path`
  stroke-dasharray: 1, 200;
  stroke-dashoffset: 0;
  animation: ${dash} 1.5s ease-in-out infinite;
  stroke-linecap: round;
`
export const SpinnerSvg = ({ size, color = '#4646FF' }: SvgProps) => (
  <Svg viewBox="25 25 50 50" >
    <Path
      cx="50"
      cy="50"
      r="20"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeMiterlimit="10"
    ></Path>
  </Svg>
);
